import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockModel } from 'src/app/core/models/BlockModel';
import { PartnerQueryStatus } from 'src/app/core/models/PartnerQueryStatus';
import { QueryCategoryModel } from 'src/app/core/models/QueryCategoryModel';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { QuerySubCategoryModel } from 'src/app/core/models/QuerySubCategoryModel';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { User } from 'src/app/core/models/user';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { UserService } from 'src/app/core/services/user.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { PriorityLevelEnum, PriorityLevelMapping } from 'src/app/core/models/PriorityLevelEnum';
import { formatDate } from '@angular/common';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { Constants } from 'src/app/constants/constants';
import { openViewAttachmentsModal, openViewCommentsModal } from '../Shared/CommonHelper';
import { QueryCommentModel } from 'src/app/core/models/QueryCommentModel';
import { NzStatus } from 'ng-zorro-antd/core/types';

@Component({
  selector: 'app-recycle-query',
  standalone: false,
  templateUrl: './recycle-query.component.html',
  styleUrl: './recycle-query.component.less'
})
export class RecycleQueryComponent {
  queryModel: QueryModel = new QueryModel();

  currentUser: User = new User();

  queryCode: number = 0;
  partnerQueryStatus: PartnerQueryStatus = PartnerQueryStatus.New;
  priorityLevelMapping = PriorityLevelMapping;
  priorityLevels = Object.values(PriorityLevelEnum);
  queryDetail: QueryDetailModel = new QueryDetailModel();
  queryComment: QueryCommentModel = new QueryCommentModel();

  blockMaster: BlockModel[] = [];
  departmentMaster: SubDepartmentModel[] = [];
  subDeptMaster: SubDepartmentModel[] = [];
  deptSubDeptMaster: SubDepartmentModel[] = [];
  categoryMaster: QueryCategoryModel[] = [];
  subCatMaster: QuerySubCategoryModel[] = [];
  partnerUserMaster: RegisteredUserModel[] = [];
  catSubCatMaster: QuerySubCategoryModel[] = [];
  selectedCCPartnerUsers = [];
  selectedCCUsers: RegisteredUserModel[] = [];
  selectedCCSubDepts: { Id: string; Value: string }[] = [];
  query: QueryModel = new QueryModel();
  output: any;
  queryStatus: string = "New";
  requestedDate: Date = new Date();


  CCSubDepartmentsMaster: { Id: string; Value: string }[] = [];

  requestorDetail: User = new User();
  subjectMaxLength: number = 80;
  dropdownSettings = {};
  dropdownSettingsDept = {};
  updateQueryForm!: FormGroup;
  files: File[] = [];
  partnerUploadedAttachmtCnt = 0;
  internalUserUploadedAttachmtCnt = 0;

  queryNewEnum = QueryStatus.New;
  queryAssignedToDeptEnum = QueryStatus.AssignedToDeptRep;
  queryAnsweredByDeptEnum = QueryStatus.QueryAnsweredByDeptRep;
  queryAnsweredBySponsorEnum = QueryStatus.QueryAnsweredBySponsor;
  queryRecycledEnum = QueryStatus.Recycled;
  queryReOpenedEnum = QueryStatus.ReOpened;

  isCategoryCommentVisible = false;
  isContractNumberVisible = false;
  isAFEVisible = false;
  isWOVisible = false;

  consolidatedCommentInString = "";
  consolidatedComment: string[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private dbMasterService: DbMasterService,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private queryService: ClarificationQueryListService,
    private fb: FormBuilder) {
    const queryCodeParam = this.route.snapshot.paramMap.get('queryCode');
    this.queryCode = queryCodeParam ? +queryCodeParam : 0;

  }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    this.getQueryDetails();
    this.initializeForm();
    this.initialiseMasterData();

    if (this.queryCode === 0) {
      this.router.navigate(['/home']);
    }
  }
  getQueryDetails() {
    this.queryService.getQueryDetail(this.queryCode, this.currentUser.User_Code ?? 0).subscribe((response: any) => {
      if (response.isAccessible) {
        this.queryModel = response.output;
        this.queryDetail = this.queryModel.QueryDetail;
        this.consolidatedCommentInString = this.queryDetail.ConsolidatedCommentInString;
        this.consolidatedComment = this.queryDetail.ConsolidatedComment as [];
        this.queryDetail.ConsolidatedCommentInString = '';
        this.queryDetail.ConsolidatedComment = [];
      }
      else {
        this.redirectToHome("You are not authorized to recycle the selected Query Details.");
      }
    }, error => {
      this.messageService.error("Error occurred while fetching the query details");
      console.log(error);
    });
  }
  initializeForm() {
    
    this.updateQueryForm = this.fb.group({

      //Clarification Request Details
      department: ['', Validators.required],
      subDepartment: ['', Validators.required],
      ccSubDepartment: [], // CC Sub Departments
      cc: [{ value: [], disabled: true }], // Multi-select dropdown
      partnerComments: [{ value: this.queryModel.QueryDetail.Partner_Comment, disabled: true }],
      Company_Restricted: [{ value: this.queryModel.QueryDetail.Company_Restricted || false, disabled: true }],
      Clarification_Cat_Code: [{ value: '', disabled: false }, Validators.required],
      Clarification_SubCat_Code: [{ value: '', disabled: false }, Validators.required],
      letterReferenceNumber: [{ value: this.queryModel.QueryDetail.LetterReference_Number, disabled: false }],
      afeNumber: [{ value: this.queryModel.QueryDetail.AFE_Number, disabled: false }],
      workOrderNumber: [{ value: this.queryModel.QueryDetail.Work_Order_Number, disabled: false }],
      contractNumber: [{ value: this.queryModel.QueryDetail.Contract_Number, disabled: false }],
      categoryComment: [{ value: this.queryModel.QueryDetail.Category_Comments, disabled: false }, Validators.required],
      additionalComments: [this.queryModel.QueryDetail.Comment, Validators.required],
    });

  }
  initialiseMasterData() {
    this.dbMasterService.getMasterDetails().subscribe({
      next: (response) => {

        this.output = response.output;
        this.blockMaster = this.output.Block as [];

        this.categoryMaster = this.output.Category as [];
        this.subCatMaster = this.output.SubCategory as [];

        this.departmentMaster = this.output.Department.filter((dept: { Active: any; }) => dept.Active) as [];
        this.subDeptMaster = this.output.SubDepartment.filter((subDept: { Active: any; }) => subDept.Active) as [];
        this.partnerUserMaster = this.output.PartnerUsers.filter((user: { Active: any; }) => user.Active) as [];
        this.deptSubDeptMaster = [];
        this.departmentMaster.forEach(element => {
          var subDepts = this.subDeptMaster.filter(a => a.Department_Code == element.Department_Code);
          subDepts.forEach(item => {
            this.CCSubDepartmentsMaster.push({ 'Id': item.Sub_Dept_Code, 'Value': element.Department_Name + ' - ' + item.Sub_Dept_Name });
          });
        });
        this.categoryMaster = this.output.Category as [];
        this.subCatMaster = this.output.SubCategory as [];
        this.partnerUserMaster = this.output.PartnerUsers.filter((s: any) => s.Active) as [];
        this.deptSubDeptMaster = this.catSubCatMaster = [];
        if (this.queryDetail.Department_Code != "0" && this.queryDetail.Department_Code != "") {
          this.deptSubDeptMaster = this.subDeptMaster.filter(item => item.Department_Code == this.queryDetail.Department_Code);
          var subDepts = this.deptSubDeptMaster.filter(a => a.Sub_Dept_Code == this.queryDetail.Sub_Dept_Code)
          if (subDepts.length == 0) {
            this.queryDetail.Sub_Dept_Code = "";
          }
        }
        if (this.queryDetail.Clarification_Cat_Code != "0" && this.queryDetail.Clarification_Cat_Code != "") {
          this.catSubCatMaster = this.subCatMaster.filter(item => item.Clarification_Cat_Code == this.queryDetail.Clarification_Cat_Code);
          this.setSubCategoryVisibility(this.queryModel.QueryDetail.Clarification_SubCat_Code);
        }
        if (this.queryDetail.CCUsers) {
          for (var i = 0; i < this.queryDetail.CCUsers.length; i++) {
            let user = this.partnerUserMaster.filter(s => s.User_Code == this.queryDetail.CCUsers[i]);
            if (user.length > 0) {
              this.selectedCCUsers.push(user[0]);
            }
          }
        }

        if (this.queryDetail.CCSubDepartments) {
          for (var i = 0; i < this.queryDetail.CCSubDepartments.length; i++) {
            let subDepts = this.CCSubDepartmentsMaster.filter(s => s.Id == this.queryDetail.CCSubDepartments[i]);
            if (subDepts.length > 0) {
              this.selectedCCSubDepts.push(subDepts[0]);
            }
          }
        }


        // Set the form values based on the query detail
        this.updateQueryForm.patchValue({
          department: this.queryDetail.Department_Code || '',
          subDepartment: this.queryDetail.Sub_Dept_Code || '',
          ccSubDepartment: this.queryDetail.CCSubDepartments || [],
          cc: this.queryDetail.CCUsers || [],
          Clarification_Cat_Code: this.queryDetail.Clarification_Cat_Code || '',
          Clarification_SubCat_Code: this.queryDetail.Clarification_SubCat_Code || '',
          letterReferenceNumber: this.queryModel.QueryDetail.LetterReference_Number,
          afeNumber: this.queryModel.QueryDetail.AFE_Number,
          workOrderNumber: this.queryModel.QueryDetail.Work_Order_Number,
          contractNumber: this.queryModel.QueryDetail.Contract_Number,
          categoryComment: this.queryModel.QueryDetail.Category_Comments,
        });

      },
      error: (err) => {
        console.error('Error fetching master details:', err);
      }
    });
  }
  //#region Dropdown Change Events

  onDepartmentChange(department_Code: string) {
    this.deptSubDeptMaster = [];
    this.queryDetail.Sub_Dept_Code = "";

    // Clear the subDepartment field in the form
    this.updateQueryForm.patchValue({
      subDepartment: ''
    });

    this.deptSubDeptMaster = this.subDeptMaster.filter(item => item.Department_Code == department_Code);
  }
  onCategorySelect(category_Code: string) {
    this.catSubCatMaster = [];
    this.queryDetail.Clarification_Cat_Code = category_Code;
    this.queryDetail.Clarification_SubCat_Code = "";
    this.catSubCatMaster = this.subCatMaster.filter(item => item.Clarification_Cat_Code == category_Code);
    this.updateQueryForm.patchValue({
      Clarification_SubCat_Code: ''
    });
    
    if (category_Code == "1" || category_Code == "2") {
      this.updateQueryForm.get('Clarification_SubCat_Code')?.setValidators(Validators.required);
      
    } else {
      this.updateQueryForm.get('Clarification_SubCat_Code')?.clearValidators();
      
    }
    this.updateQueryForm.get('Clarification_SubCat_Code')?.updateValueAndValidity();
    
    this.resetToDefault();
  }
  onSubCategorySelect(SubCategory_Code: string) {
    this.resetToDefault();
    this.queryDetail.Clarification_SubCat_Code = SubCategory_Code ?? '';
    this.setSubCategoryVisibility(SubCategory_Code);
  }
  // Handle requestor change
  onRequestorChange(selectedUser: RegisteredUserModel): void {
    if (selectedUser) {
      this.updateQueryForm.patchValue({
        requestorEmail: selectedUser.Email,
        company: selectedUser.Company?.Company_Name,
        block: selectedUser.Block?.Block_Name
      });
    }
  }
  //#endregion
  ifFormIsValid(): boolean {
    if (this.updateQueryForm.valid) {
      return true;
    } else {
      this.updateQueryForm.markAllAsTouched();
      this.logReasonForInvalidForm();
      return false;
    }
  }
  logReasonForInvalidForm() {
    
    Object.keys(this.updateQueryForm.controls).forEach(key => {
      const controlErrors = this.updateQueryForm.get(key)?.errors;
      if (controlErrors) {
        console.log(`Field: ${key}, Errors:`, controlErrors);
      }
    });
  }
  openRecycleQueryModal() {
    if (!this.ifFormIsValid())
      return;
    this.modalService.confirm({
      nzTitle: 'Confirm!',
      nzContent: `Are you sure, you want to <b>Recycle Query?</b>`,
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzClosable: false,
      nzOkDanger: true,
      nzOnOk: () => this.RecycleQuery(),
      nzCancelText: 'No'
    });
  }

  RecycleQuery() {
    
    this.assignFormValuesToQueryModel();
    this.queryService.recycleQuery(this.queryDetail, this.files).subscribe({
      next: (response: any) => {
        this.messageService.success("The query has been recycled successfully!", {
          nzDuration: Constants.SHOW_MESSAGE_DURATION,
        });
        this.router.navigate(['/clarification-query/all_query_request']);
      },
      error: (err: any) => {
        console.error("Error occurred while recycling the query:", err);
        this.messageService.error(err.error || "An error occurred while recycling the query.");
      }
    });
  }
  assignFormValuesToQueryModel() {
    this.queryDetail.Department_Code = this.updateQueryForm.value.department;
    this.queryDetail.Sub_Dept_Code = this.updateQueryForm.value.subDepartment;
    this.queryDetail.CCSubDepartments = this.updateQueryForm.value.ccSubDepartment || [];
    this.queryDetail.CCUsers = this.updateQueryForm.value.cc || [];
    this.queryDetail.Clarification_Cat_Code = this.updateQueryForm.value.Clarification_Cat_Code;
    this.queryDetail.Clarification_SubCat_Code = this.updateQueryForm.value.Clarification_SubCat_Code;

    this.queryDetail.LetterReference_Number = this.updateQueryForm.value.letterReferenceNumber;
    this.queryDetail.Contract_Number = this.updateQueryForm.value.contractNumber;
    this.queryDetail.AFE_Number = this.updateQueryForm.value.afeNumber;
    this.queryDetail.Work_Order_Number = this.updateQueryForm.value.workOrderNumber;
    this.queryDetail.Category_Comments = this.updateQueryForm.value.categoryComment;
    this.queryDetail.Comment = this.updateQueryForm.value.additionalComments;
    this.queryDetail.Modified_By = (this.currentUser.User_Code ?? 0).toString();
  }
  resetToDefault() {
    this.isCategoryCommentVisible = this.isContractNumberVisible = this.isAFEVisible = this.isWOVisible = false;
    this.queryDetail.LetterReference_Number = '';
    this.queryDetail.Contract_Number = '';
    this.queryDetail.AFE_Number = '';
    this.queryDetail.Work_Order_Number = '';
    this.queryDetail.Category_Comments = '';

    this.updateQueryForm.patchValue({
      letterReferenceNumber: this.queryDetail.LetterReference_Number,
      contractNumber: this.queryDetail.Contract_Number,
      afeNumber: this.queryDetail.AFE_Number,
      workOrderNumber: this.queryDetail.Work_Order_Number,
      categoryComment: this.queryDetail.Category_Comments
    });

  }
  public getNzStatusColor(control: string): NzStatus {
    const formControl = this.updateQueryForm.get(control);
    if (formControl?.touched && formControl.invalid) {
      return 'error';
    }
    return '';
  }
  setSubCategoryVisibility(SubCategory_Code: string) {
    
    switch (SubCategory_Code?.toString()) {
      case "1":
      case "5":
        this.isContractNumberVisible = true;
        break;
      case "2":
      case "6":
        this.isAFEVisible = true;
        break;
      case "3":
      case "7":
        this.isWOVisible = true;
        break;
      case "4":
      case "8":
        this.isCategoryCommentVisible = true;
        break;
    }
    this.enforcedCategoryCommentAsRequired();
  }
  enforcedCategoryCommentAsRequired() {
    if (this.isCategoryCommentVisible) {
      this.updateQueryForm.get('categoryComment')?.setValidators(Validators.required);
    } else {
      this.updateQueryForm.get('categoryComment')?.clearValidators();
    }
    this.updateQueryForm.get('categoryComment')?.updateValueAndValidity();
  }
  viewAttachments(viewPartnerUploadedFiles: boolean) {
    openViewAttachmentsModal(this.modalService, this.queryModel.QueryDetail, viewPartnerUploadedFiles);
  }
  viewComments() {
    openViewCommentsModal(this.modalService, this.queryModel.Query_Reference_Number, this.consolidatedComment);
  }
  redirectToHome(erroMsg: string) {
    this.messageService.error(erroMsg);
    console.log(erroMsg);
    this.router.navigate(['/home']);
  }
}
